import { useTranslation } from 'react-i18next';
import { sortByOrder } from '../../../../utils/helpers';
import { useGroupsStore } from '../../store/groups';

export const useGroups = () => {
  const { t } = useTranslation('groups');
  const { groups: userGroups, loading } = useGroupsStore((s) => s);

  const groups = userGroups
    .map((userGroup) => ({
      ...userGroup,
      group: {
        ...userGroup.group,
        name: userGroup.group.isDefaultGroup ? t('favourites.header') : userGroup.group.name,
        iconName: userGroup.group.iconName,
      },
    }))
    .sort(sortByOrder);

  const favouriteGroup = userGroups.find((userGroup) => userGroup.group.isDefaultGroup);

  return { groups, favouriteGroup, dashboardLoading: loading };
};
